/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Completed_SuccessfullyInputs */

const en_team_sync_completed_successfully = /** @type {(inputs: Team_Sync_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync completed successfully`)
};

const fr_team_sync_completed_successfully = /** @type {(inputs: Team_Sync_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisation terminée avec succès`)
};

const de_team_sync_completed_successfully = /** @type {(inputs: Team_Sync_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisierung erfolgreich abgeschlossen`)
};

const it_team_sync_completed_successfully = /** @type {(inputs: Team_Sync_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizzazione completata con successo`)
};

const ru_team_sync_completed_successfully = /** @type {(inputs: Team_Sync_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Синхронизация успешно завершена.`)
};

const es_team_sync_completed_successfully = /** @type {(inputs: Team_Sync_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronización completada exitosamente`)
};

const zh_cn2_team_sync_completed_successfully = /** @type {(inputs: Team_Sync_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同步已成功完成`)
};

const ja_team_sync_completed_successfully = /** @type {(inputs: Team_Sync_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同期が正常に完了しました`)
};

const hi_team_sync_completed_successfully = /** @type {(inputs: Team_Sync_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सिंक्रोनाइज़ेशन सफलतापूर्वक पूरा हुआ`)
};

const pt_pt2_team_sync_completed_successfully = /** @type {(inputs: Team_Sync_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronização concluída com sucesso`)
};

/**
* | output |
* | --- |
* | "Sync completed successfully" |
*
* @param {Team_Sync_Completed_SuccessfullyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_completed_successfully = /** @type {((inputs?: Team_Sync_Completed_SuccessfullyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Completed_SuccessfullyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_sync_completed_successfully(inputs)
	if (locale === "de") return de_team_sync_completed_successfully(inputs)
	if (locale === "it") return it_team_sync_completed_successfully(inputs)
	if (locale === "ru") return ru_team_sync_completed_successfully(inputs)
	if (locale === "es") return es_team_sync_completed_successfully(inputs)
	if (locale === "zh-CN") return zh_cn2_team_sync_completed_successfully(inputs)
	if (locale === "ja") return ja_team_sync_completed_successfully(inputs)
	if (locale === "hi") return hi_team_sync_completed_successfully(inputs)
	if (locale === "pt-PT") return pt_pt2_team_sync_completed_successfully(inputs)
	return en_team_sync_completed_successfully(inputs)
});